var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1103 6.37012C7.62754 5.87663 6.84483 5.87663 6.36207 6.37012C5.87931 6.86361 5.87931 7.66372 6.36207 8.15721L14.2677 16.2386L6.83027 23.8413C6.34751 24.3348 6.34751 25.1349 6.83027 25.6284C7.31303 26.1219 8.09574 26.1219 8.5785 25.6284L16.0159 18.0256L23.4207 25.595C23.9034 26.0885 24.6861 26.0885 25.1689 25.595C25.6516 25.1015 25.6516 24.3014 25.1689 23.8079L17.7641 16.2386L25.6371 8.19057C26.1199 7.69707 26.1199 6.89697 25.6371 6.40347C25.1543 5.90998 24.3716 5.90998 23.8889 6.40347L16.0159 14.4515L8.1103 6.37012Z",
    fill: "#1E2527"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon24X24);
export default __webpack_public_path__ + "static/media/close_icon_24x24.ed93370a6059731c5c405afe14adbdd0.svg";
export { ForwardRef as ReactComponent };